/* Privacy Policy

Last updated: October 15, 2023

Welcome to TELLMIZ ("we," "us," or "our"). We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application TELLMIZ (the "App").

1. Information We Collect

We may collect the following types of information:

Personal Data: Information such as your name, email address, and phone number when you register or interact with the App.
Usage Data: Details about your access and use of the App, including traffic data, logs, and other communication data.
Device Information: Information about your device, including hardware model, operating system, and unique device identifiers.
Location Data: Precise or approximate location data from your mobile device if you grant permission.
2. How We Collect Information

Directly from You: When you provide information by creating an account, filling out forms, or contacting customer support.
Automatically: Through cookies, log files, and other tracking technologies when you use the App.
From Third Parties: Such as social media platforms if you choose to link your account.
3. Use of Your Information

We use your information to:

Provide, maintain, and improve the App's functionality.
Personalize your experience and deliver content relevant to your interests.
Communicate with you about updates, offers, and promotional materials.
Monitor and analyze usage patterns to enhance user experience.
Prevent fraudulent transactions and protect against security threats.
4. Sharing of Your Information

We may share your information with:

Third-Party Service Providers: Including analytics tools, advertising networks, and third-party SDKs that perform services on our behalf. These parties are obligated to protect your data to the same extent as outlined in this Privacy Policy.
Affiliates and Subsidiaries: Any parent company, subsidiaries, joint ventures, or other companies under common control.
Legal Obligations: If required by law, we may disclose your information to comply with legal processes.
5. Data Protection by Third Parties

All third parties with whom we share your data are required to:

Provide the same level of data protection as stated in this Privacy Policy.
Use your data only for the purposes outlined by us and in compliance with applicable laws and guidelines.
Implement appropriate security measures to safeguard your information.
6. Data Retention and Deletion

Retention: We retain your personal data only as long as necessary to fulfill the purposes outlined in this Privacy Policy.
Deletion: You may request deletion of your personal data at any time by contacting us at [Contact Email Address]. We will respond to your request within 30 days.
7. Revoking Consent and Your Rights

Access and Correction: You have the right to access and correct your personal information held by us.
Revocation of Consent: You may withdraw your consent for data collection and processing at any time.
Opt-Out: You can opt-out of receiving promotional communications by following the unsubscribe instructions in those messages or contacting us directly.
8. Security Measures

We implement industry-standard security measures to protect your information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.

9. Children's Privacy

Our App is not intended for use by children under the age of 13. We do not knowingly collect personal information from children under 13.

10. Changes to This Privacy Policy

We may update this Privacy Policy periodically. Any changes will be posted within the App and updated on the "Last updated" date above.

11. Contact Us

If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:

Email: [Contact Email Address]
Address: [Company Address]
By using our App, you acknowledge that you have read and understood this Privacy Policy and agree to our collection, use, and sharing of your information as described herein. */

// PrivacyPolicy.jsx

import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <h1 className="privacy-heading">Privacy Policy</h1>
      <p className="tos-date">Last updated: January 20, 2025</p>

      <p>
        Welcome to <strong>TELLMIZ</strong> ("we," "us," or "our"). We are committed to protecting your personal
        information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard
        your information when you use our mobile application <strong>TELLMIZ</strong> (the "App").
      </p>

      <h2>1. Information We Collect</h2>
      <p>We may collect the following types of information:</p>
      <ul>
        <li>
          <strong>Personal Data</strong>: Information such as your name, email address, and phone number when you
          register or interact with the App.
        </li>
        <li>
          <strong>Usage Data</strong>: Details about your access and use of the App, including traffic data, logs, and
          other communication data.
        </li>
        <li>
          <strong>Device Information</strong>: Information about your device, including hardware model, operating
          system, and unique device identifiers.
        </li>
        <li>
          <strong>Location Data</strong>: Precise or approximate location data from your mobile device if you grant
          permission.
        </li>
      </ul>

      <h2>2. How We Collect Information</h2>
      <p>We collect information:</p>
      <ul>
        <li>
          <strong>Directly from You</strong>: When you provide information by creating an account, filling out forms, or
          contacting customer support.
        </li>
        <li>
          <strong>Automatically</strong>: Through cookies, log files, and other tracking technologies when you use the
          App.
        </li>
        <li>
          <strong>From Third Parties</strong>: Such as social media platforms if you choose to link your account.
        </li>
      </ul>

      <h2>3. Use of Your Information</h2>
      <p>
        We use your information to:
      </p>
      <ul>
        <li>
          Provide, maintain, and improve the App's functionality.
        </li>
        <li>
          Personalize your experience and deliver content relevant to your interests.
        </li>
        <li>
          Communicate with you about updates, offers, and promotional materials.
        </li>
        <li>
          Monitor and analyze usage patterns to enhance user experience.
        </li>
        <li>
          Prevent fraudulent transactions and protect against security threats.
        </li>
      </ul>

      <h2>4. Sharing of Your Information</h2>
      <p>We may share your information with:</p>
      <ul>
        <li>
          <strong>Third-Party Service Providers</strong>: Including analytics tools, and third-party SDKs that perform services on our behalf. These parties are obligated to protect your data to the same extent as outlined in this Privacy Policy.
        </li>
        <li>
          <strong>Affiliates and Subsidiaries</strong>: Any parent company, subsidiaries, joint ventures, or other companies under common control.
        </li>
        <li>
          <strong>Legal Obligations</strong>: If required by law, we may disclose your information to comply with legal processes.
        </li>
      </ul>

      <h2>5. Data Protection by Third Parties</h2>
      <p>All third parties with whom we share your data are required to:</p>
      <ul>
        <li>
          Provide the same level of data protection as stated in this Privacy Policy.
        </li>
        <li>
          Use your data only for the purposes outlined by us and in compliance with applicable laws and guidelines.
        </li>
        <li>
          Implement appropriate security measures to safeguard your information.
        </li>
      </ul>

      <h2>6. Data Retention and Deletion</h2>
      <p>
        <strong>Retention</strong>: We retain your personal data only as long as necessary to fulfill the purposes outlined in this Privacy Policy.
      </p>
      <p>
        <strong>Deletion</strong>: You may request deletion of your personal data at any time by contacting us at jade1992amine. We will respond to your request within 30 days.
      </p>

      <h2>7. Revoking Consent and Your Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>
          <strong>Access and Correction</strong>: You have the right to access and correct your personal information held by us.
        </li>
        <li>
          <strong>Revocation of Consent</strong>: You may withdraw your consent for data collection and processing at any time.
        </li>
        <li>
          <strong>Opt-Out</strong>: You can opt-out of receiving promotional communications by following the unsubscribe instructions in those messages or contacting us directly.
        </li>
      </ul>

      <h2>8. Security Measures</h2>
      <p>
        We implement industry-standard security measures to protect your information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.
      </p>

      {/* <h2>9. Children's Privacy</h2>
      <p>
        Our App is not intended for use by children under the age of 13. We do not knowingly collect personal information from children under 13.
      </p> */}

      <h2>9. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy periodically. Any changes will be posted within the App and updated on the "Last updated" date above.
      </p>

      <h2>10. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:
      </p>
      <ul>
        <li>
          <strong>Email</strong>: jade1992amine@gmail.com
        </li>
        <li>
          <strong>Phone</strong>: +356 7962 9890
        </li>
      </ul>

      <p className="privacy-footer">
        ---
        <br />
        By using our App, you acknowledge that you have read and understood this Privacy Policy and agree to our
        collection, use, and sharing of your information as described herein.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
